import { render } from "./TheVanDongVienTheThao.vue?vue&type=template&id=aa9fe18e"
import script from "./TheVanDongVienTheThao.vue?vue&type=script&lang=js"
export * from "./TheVanDongVienTheThao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__